import SystemDashboard from '@/models/SystemDashboard'
import SystemDashboardWidget from '@/models/SystemDashboardWidget'
import FYOverviewWidget from '../widgets/finance/FYOverviewWidget'
import RevenueSegmentsWidget from '../widgets/finance/RevenueSegmentsWidget'
import ClosedBusinessWidget from '../widgets/sales/ClosedBusinessWidget'
import AdditionalRevenueWonQTR from '../widgets/finance/AdditionalRevenueWonQTR'

export default class SLTQTRModule extends SystemDashboard {
  public title: string = 'SLT - QTR'

  public key = 'slt_qtr_dashboard'

  public querySettings = {
    company_fields: [
      {
        name: 'holding',
        key: 'holding',
        type: 'holding',
      },
      {
        name: 'agency',
        key: 'agency',
        type: 'agency',
      },
      {
        name: 'advertiser',
        key: 'advertiser',
        type: 'advertiser',
      },
    ],
    custom_fields: [
      {
        name: 'deal_type:direct',
        value: 'deal_type:direct',
      },
      {
        name: 'deal_type:3rd Party',
        value: 'deal_type:3rd_party',
      },
    ],
    user_fields: [
      {
        name: 'sr',
        key: 'sales_rep_id',
      },
      {
        name: 'sm',
        key: 'sales_manager_id',
      },
    ],
  }

  public widgets: SystemDashboardWidget[] = [
    new FYOverviewWidget(),
    new RevenueSegmentsWidget({
      title: 'Sales Channel',
      key: 'sales-channel',
      target: 'channel',
    }),
    new AdditionalRevenueWonQTR(),
    new ClosedBusinessWidget(),
  ]
}
